import React, { useState, useEffect, useRef } from "react";
import "./LoginPage.css";
import logo from "../Assets/logocredentials.svg";
import { useNavigate } from "react-router-dom";
import eye from "../Assets/EyeFill.svg";
import passwordHide from "../Assets/passwordHide.svg";
import api from "../services/api";
import { useToast } from "../mesageToast/ToastContainer";
import { useQueryClient } from '@tanstack/react-query';

// import { useToast } from "../mesageToast/ToastContainer";

// import ForgotPassword from "../forgotpassword/ForgotPassword";
// import NewPasswordSection from "../forgotpassword/NewPasswordSection";

function VendorLoginform() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  //const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);
  const [isNewPasswordSectionOpen, setIsNewPasswordSectionOpen] =
    useState(false);
  const [emailError, setEmailError] = useState(""); // New state for error message
  const [passwordError, setPasswordError] = useState(""); // New state for password error

  const emailRef = useRef();

  const navigate = useNavigate();
  const addToast = useToast();
  const queryClient = useQueryClient();

  const handleLogin = (e) => {
    e.preventDefault();
    let valid = true;

    // Validate email
    if (!validateEmail(email)) {
      setEmailError("Please enter a valid email address");
      valid = false;
    } else {
      setEmailError("");
    }

    // Validate password
    if (!password) {
      setPasswordError("Please enter a password");
      valid = false;
    } else {
      setPasswordError("");
    }

    // Stop if there are validation errors
    if (!valid) return;

    // Implement login logic here
    api
      .post("/login", { email, password })
      .then((response) => {
        addToast("Login Success", "You have logged in successfully.", "success");
        const token = response.data.token;
        const userData = response.data.data;
        
        localStorage.setItem("token", token);
        localStorage.setItem("userRole", userData.role);
        localStorage.setItem("userDesignation", userData.designation);
        localStorage.setItem("userData", JSON.stringify(userData));
        localStorage.setItem("user", JSON.stringify(userData)); // For compatibility
        
        // Clear all cached data on login to ensure fresh data
        queryClient.clear();
        
        navigate(response.data.redirectPath);
      })
      .catch((error) => {
        addToast("Login Failed", "Invalid email or password.", "error");
        console.log(error);
      });
  };
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      localStorage.clear();
      sessionStorage.clear();
    }
  }, []);

  // const handleSignupClicked = () => {
  //   handleViewChange("signup");
  // };
  // const handleForgotPassword = () => {
  //   setIsForgotPasswordOpen(true); // Open the ForgotPassword modal
  // };
  // const closeForgotPasswordModal = () => {
  //   setIsForgotPasswordOpen(false); // Close the modal
  // };
  // const showNewPasswordModal = () => {
  //   setIsForgotPasswordOpen(false); // Close the modal
  //   setIsNewPasswordSectionOpen(true); // Open the modal NewPasswordSection
  // };
  // const closeNewPasswordModal = () => {
  //   setIsNewPasswordSectionOpen(false); // Close the modal
  // };
  // Email validation function
  const validateEmail = (email) => {
    const trimmedEmail = email.replace(/\s+/g, ""); // Remove spaces
    const emailRegex = /^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/; // Specified format
    return emailRegex.test(trimmedEmail);
  };

  const handleEmailChange = (e) => {
    const inputEmail = e.target.value.replace(/\s+/g, ""); // Remove spaces in real-time
    setEmail(inputEmail);

    if (!validateEmail(inputEmail)) {
      setEmailError("");
    } else {
      setEmailError(""); // Clear the error if valid
    }
  };
  const handleEmailBlur = () => {
    if (!email) {
      setEmailError("");
    }
  };
  const handlePasswordBlur = () => {
    if (!password) {
      setPasswordError("");
    }
  };
  const handleEmailKeyDown = (e) => {
    if (e.key === " ") {
      setEmailError("Spaces are not allowed in the email field.");
      e.preventDefault(); // Prevent space from being entered
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (email && emailRef.current && !emailRef.current.contains(e.target)) {
        setEmailError("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [email]);

  return (
    <div>
      <div className="login-container">
        <div className="login-box">
          <img src={logo} alt="Logo" className="logo" />
          <h1>Hi, Welcome👋</h1>
          <p className="welcome-text">Please login to continue</p>
          <form onSubmit={handleLogin}>
            <div className="input-group">
              <label>Email</label>
              <input
                type="text"
                value={email}
                ref={emailRef}
                onChange={handleEmailChange}
                onBlur={handleEmailBlur}
                onKeyDown={handleEmailKeyDown} // Handle key press
                maxLength={50}
                placeholder="sophat.leat@nintrea.live"
                style={{
                  border: emailError ? "1px solid red" : "1px solid #ccc",
                }}
              />
              {emailError && <p className="error-message">{emailError}</p>}
            </div>
            <div className={`input-group ${passwordError ? "error" : ""}`}>
              <label>Password</label>
              <div className="password-container">
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onBlur={handlePasswordBlur}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    if (e.target.value) {
                      setPasswordError(""); // Clear error if textarea has value
                    }
                  }}
                  placeholder="Please Enter Your Password"
                  style={{
                    border: passwordError ? "1px solid red" : "1px solid #ccc",
                  }}
                />
                {passwordError && (
                  <p className="error-message">{passwordError}</p>
                )}

                <span
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <img src={eye} alt="show" />
                  ) : (
                    <img src={passwordHide} alt="hide" />
                  )}{" "}
                </span>
              </div>
            </div>
            {/* <div className="options">
              <label className="remember-me">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                Remember Me
              </label>
              <a className="forgot-password" onClick={handleForgotPassword}>
                Forgot Password
              </a>
            </div> */}
            <button type="submit" className="login-button">
              Login
            </button>
          </form>
          {/* <p className="sign-up">
            Don't have an account? <a onClick={handleSignupClicked}>Sign Up</a>
          </p> */}
        </div>
      </div>
      {/* Modal for ForgotPassword */}
      {/* {isForgotPasswordOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <ForgotPassword
              onClose={closeForgotPasswordModal}
              onContinue={showNewPasswordModal}
            />
          </div>
        </div>
      )} */}
      {/* Modal for NewPasswordSection */}
      {/* {isNewPasswordSectionOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <NewPasswordSection onClose={closeNewPasswordModal} />
          </div>
        </div>
      )} */}
    </div>
  );
}

export default VendorLoginform;
